<template>
  <header class="exit-nav-bar">
    <div class="exit-nav-bar-cnt" data-cy="exit-nav-bar">
      <router-link to="/">
        <BackstageIcon class="header-logo" name="black-logo" data-cy="black-logo" />
      </router-link>
      <h4 class="title" data-cy="title">
        {{ title }}
      </h4>
      <div class="buttons-cnt">
        <BackstageButton
          :variant="ButtonVariant.SECONDARY"
          data-cy="exit-button-cnt"
          data-cy-button="exit-button"
          v-on:click="$emit('exit')">
          {{ $t('global.exit_button') }}
        </BackstageButton>
        <HeaderAccount hide-account-info />
      </div>
    </div>
  </header>
</template>
<script lang="ts">
import BackstageButton from '@/components/common/BackstageButton.vue';
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import HeaderAccount from '@/layouts/header/HeaderAccount.vue';
import { ButtonVariant } from '@/models/button-variant.enum';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'exit-nav-bar',
  components: {
    HeaderAccount,
    BackstageButton,
    BackstageIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      ButtonVariant,
    };
  },
});
</script>
<style scoped lang="scss">
.exit-nav-bar {
  width: 100%;
  background-color: var(--primary-bg-color);

  .exit-nav-bar-cnt {
    @include main-max-with;

    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 4rem;
    padding: 0 1.25rem;

    .header-logo {
      width: 2.0625rem;
      height: 2.0625rem;
    }

    .title {
      margin-left: 36px;
      font-size: 14px;
      font-weight: 700;
      text-transform: capitalize;
    }

    .buttons-cnt {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    @include breakpoint(small) {
      padding: 0 8px;

      .title {
        margin-left: 8px;
      }
    }
  }
}
</style>
